import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CreateFolderRequest, FolderDto } from '../models/folder.model';

@Injectable({ providedIn: 'root' })
export class FolderService {
  private readonly api = inject(ApiService);

  getChildren(parentId?: number | null): Observable<FolderDto[]> {
    return this.api.get<FolderDto[]>('/folders/children', { parentId: parentId ?? '' });
  }

  create(request: CreateFolderRequest): Observable<FolderDto> {
    return this.api.post<FolderDto>('/folders', request);
  }
  getAll(): Observable<FolderDto[]> {
    return this.api.get<FolderDto[]>('/folders/all');
  }
  delete(folderId: number) {
    return this.api.delete<void>(`/folders/${folderId}`);
  }
}
